module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "general-select"
  }, [(_vm.label) ? _c('label', {
    staticClass: "general-select-label mb-1",
    class: _vm.lightLabel ? 'light' : ''
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "select",
    staticClass: "general-select-value d-flex align-items-center",
    class: [_vm.error ? 'error' : ''],
    on: {
      "click": _vm.toggleList
    }
  }, [(_vm.selected && _vm.selected.indicatorColor) ? _c('div', {
    staticClass: "general-select-indicator",
    style: (_vm.selected.indicatorColor ? ("background: " + (_vm.selected.indicatorColor) + ";") : '')
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "general-select-text",
    class: !_vm.selected ? 'placeholder' : ''
  }, [_vm._v("\n            " + _vm._s(_vm.selected ? _vm.selected.label : _vm.placeholder) + "\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  }, [_vm._v("▼")])]), _vm._v(" "), _c('div', {
    staticClass: "general-select-options"
  }, _vm._l((_vm.options), function(option, i) {
    return _c('div', {
      key: i,
      staticClass: "general-select-option d-flex align-items-center",
      class: _vm.selected == option ? 'selected' : '',
      on: {
        "click": function($event) {
          return _vm.selectOption(option)
        }
      }
    }, [(option.indicatorColor) ? _c('div', {
      staticClass: "general-select-indicator",
      style: (option.indicatorColor ? ("background: " + (option.indicatorColor) + ";") : '')
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "general-select-text"
    }, [_vm._v(_vm._s(option.label))]), _vm._v(" "), (_vm.selected == option) ? _c('span', [_vm._v("\n                ✓\n            ")]) : _vm._e()])
  }), 0), _vm._v(" "), (_vm.error) ? _c('small', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d74d6888"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/Input/GeneralSelect.vue
// module id = 1341
// module chunks = 1